import React, { useContext } from "react"
import { ResolveOrderExceptionContext } from "../ResolveOrderException.context"
import { Form, Input, Button, Select } from "antd"
import { useFormik } from "formik"
import * as yup from "yup"
import { steps } from "../constants"
import SelectStates from "../../../common/SelectStates"
import SelectCities from "../../../common/SelectCities"

const { Option } = Select


const ConsigneeDetails = () => {
  const {
    orderData
  } = useContext(ResolveOrderExceptionContext)
  if (orderData.length > 1) {
    return <BulkCheckConsignee />
  }
  return <ConsigneeDetailsForms order={orderData[0]} />
}


const ConsigneeDetailsForms = ({ order }) => {
  const {
    handleCloseModal,
    saveData, setCurrentStep,
    collectedData, submitResponse,
    orderData
  } = useContext(ResolveOrderExceptionContext)

  const { redeliver_exceptions } = collectedData
  const consigneeDetails = (redeliver_exceptions && redeliver_exceptions[0]) || {}

  const initialValues = {
    order_id: order.order_id,
    consignee_name: consigneeDetails.consignee_name || order.consignee_name || undefined,
    consignee_address: consigneeDetails.consignee_address || order.consignee_address || undefined,
    consignee_postal: consigneeDetails.consignee_postal || order.consignee_postal || undefined,
    consignee_state: consigneeDetails.consignee_state || order.consignee_state || undefined,
    consignee_city: consigneeDetails.consignee_city || order.consignee_city || undefined,
    consignee_country: consigneeDetails.consignee_country || order.consignee_country || undefined,
    consignee_number: consigneeDetails.consignee_number || order.consignee_number || undefined,
    consignee_email: consigneeDetails.consignee_email || order.consignee_email || undefined,
    payment_type: consigneeDetails.payment_type || order.payment_type || undefined,
    cod_amt_to_collect: consigneeDetails.cod_amt_to_collect || order.cod_amt_to_collect || undefined,
  }
  const validationSchema = yup.object().shape({
    consignee_name: yup.string().nullable(),
    consignee_address: yup.string().nullable(),
    consignee_postal: yup.string().nullable(),
    consignee_state: yup.string().nullable(),
    consignee_city: yup.string().nullable(),
    consignee_country: yup.string().nullable(),
    consignee_number: yup.string().nullable(),
    consignee_email: yup.string().nullable(),
    payment_type: yup.string().nullable(),
    cod_amt_to_collect: yup.number("Enter a valid number").nullable(),
  })

  const onSubmit = async (values, { setSubmitting, setErrors }) => {
    saveData({
      redeliver_exceptions: [values]
    })
    setCurrentStep(steps.leaveNote)
  }

  let initialErrors = {}
  if (orderData.length === 1 && submitResponse?.isError && submitResponse?.error?.redeliver_exceptions) {
    const errorData = submitResponse.error?.redeliver_exceptions[0]
    initialErrors = {...errorData}
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    initialErrors,
    initialTouched: initialErrors,
    enableReinitialize: true
  })

  const getErrorsProps = fieldName => {
    if (formik.touched[fieldName] && formik.errors[fieldName]) {
      return {
        validateStatus: "error",
        help: formik.errors[fieldName],
        hasFeedback: true
      };
    }
    return {};
  };
  const getFieldProps = (fieldName, forceDisabled=false) => ({
    name: fieldName,
    autoComplete: "off",
    value: formik.values[fieldName],
    onChange: formik.handleChange,
    disabled: formik.isSubmitting || forceDisabled
  });
  const disabledCountry = true

  return (
    <form onSubmit={formik.handleSubmit}>
      <h6>Check consignee details</h6>
      <div className="mt-4">
        <div className="row">
          <div className="col-md-6">
            <Form.Item
              label="Consignee Full Name"
              colon={false}
              {...getErrorsProps('consignee_name')}
              >
                <Input
                  placeholder="Consignee Full Name"
                  {...getFieldProps('consignee_name')} />
            </Form.Item>
          </div>
          <div className="col-md-6">
            <Form.Item
              label="Consignee Phone Number"
              colon={false}
              {...getErrorsProps('consignee_number')}
              >
                <Input
                  placeholder="Consignee Phone Number"
                  {...getFieldProps('consignee_number')} />
            </Form.Item>
          </div>
          <div className="col-md-6">
            <Form.Item
              label="Consignee Email"
              colon={false}
              {...getErrorsProps('consignee_email')}
              >
                <Input
                  placeholder="Consignee Email"
                  {...getFieldProps('consignee_email')} />
            </Form.Item>
          </div>
          <div className="col-md-6">
            <Form.Item
              label="Consignee Address"
              colon={false}
              {...getErrorsProps('consignee_address')}
              >
                <Input
                  placeholder="Consignee Address"
                  {...getFieldProps('consignee_address')} />
            </Form.Item>
          </div>
          <div className="col-md-6">
            <Form.Item
              label="Consignee Country"
              colon={false}
              {...getErrorsProps('consignee_country')}
              >
                <Input
                  placeholder="Consignee Country"
                  {...getFieldProps('consignee_country', disabledCountry)} />
            </Form.Item>
          </div>
          <div className="col-md-6">
            <Form.Item
              label="Consignee State"
              colon={false}
              {...getErrorsProps('consignee_state')}
              >
                <SelectStates
                  country={formik.values.consignee_country}
                  onChange={value => {
                    formik.setFieldValue("consignee_state", value)
                    formik.setFieldValue("consignee_city", null)
                  }}
                  value={formik.values.consignee_state}
                />
            </Form.Item>
          </div>
          <div className="col-md-6">
            <Form.Item
              label="Consignee City"
              colon={false}
              {...getErrorsProps('consignee_city')}
              >
                <SelectCities
                  country={formik.values.consignee_country}
                  state={formik.values.consignee_state}
                  value={formik.values.consignee_city}
                  onChange={value => {
                    formik.setFieldValue("consignee_city", value)
                  }}
                />
            </Form.Item>
          </div>
          <div className="col-md-6">
            <Form.Item
              label="Consignee Province"
              colon={false}
              {...getErrorsProps('consignee_province')}
              >
                <Input
                  placeholder="Consignee Province"
                  {...getFieldProps('consignee_province')} />
            </Form.Item>
          </div>
          <div className="col-md-6">
            <Form.Item
              label="Consignee Postal Code"
              colon={false}
              {...getErrorsProps('consignee_postal')}
              >
                <Input
                  placeholder="Consignee Postal Code"
                  {...getFieldProps('consignee_postal')} />
            </Form.Item>
          </div>
          <div className="col-md-6">
            <Form.Item
              label="Payment Type"
              colon={false}
              {...getErrorsProps('payment_type')}
              >
                <Select style={{ width: "100%" }} placeholder="Select payment type"
                  onChange={value => formik.setFieldValue("payment_type", value)}
                  value={formik.values.payment_type}>
                  <Option value="prepaid">Prepaid</Option>
                  <Option value="cod">COD</Option>
                </Select>
            </Form.Item>
          </div>
          <div className="col-md-6">
            <Form.Item
              label="COD Amount to collect"
              colon={false}
              {...getErrorsProps('cod_amt_to_collect')}
              >
                <Input
                  placeholder="COD Amount to collect"
                  {...getFieldProps(
                    'cod_amt_to_collect',
                    ["Prepaid", "prepaid"].includes(formik.values.payment_type)
                    )} />
            </Form.Item>
          </div>
        </div>
      </div>

      {formik.errors.order_id &&
      <div className="mt-3">
        <p className="mb-0 text-danger">{formik.errors.order_id}</p>
      </div>
      }
      {formik.errors.non_field_errors &&
      <div className="mt-3">
        {formik.errors.non_field_errors.map((err, i) => (
          <p className="mb-1 text-danger" key={i}>{err}</p>
        ))}
      </div>
      }

      <div className="mt-5 d-flex justify-content-between align-items-center">
        <div></div>
        <div>
          <Button className="mr-2" onClick={() => handleCloseModal()} disabled={formik.isSubmitting}>Cancel</Button>
          <Button type="primary" htmlType="submit" disabled={formik.isSubmitting}>
            {formik.isSubmitting? "Processing...":"Proceed"}
          </Button>
        </div>
      </div>
    </form>
  )
}

const BulkCheckConsignee = () => {
  const {
    setCurrentStep
  } = useContext(ResolveOrderExceptionContext)
  return (
    <div>
      <h6>Check consignee details</h6>
      <div className="mt-4">
        <p className="mb-0">Are there any order details to be corrected? If so, please select them for redelivery individually. Redelivery for selected orders will be resubmitted with their existing data.</p>
      </div>

      <div className="mt-5 d-flex justify-content-between align-items-center">
        <div></div>
        <div>
          <Button type="primary" htmlType="button" onClick={() => setCurrentStep(steps.leaveNote)}>OK</Button>
        </div>
      </div>
    </div>
  )
}

export default ConsigneeDetails